import { Col, Row, Spinner } from "reactstrap";

export default function SapLoading () {
    return <Row className="m-4">
        <Col className="text-center">
            <Spinner color="secondary" size="sm" className="me-2" />
            Loading...
        </Col>
    </Row>
}